import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

function isSuccessReduxSelector (path) {
  return state => getObjectUtil(state, `${path}.status`) === REDUX_STATUS.SUCCESS
}

export default isSuccessReduxSelector
